import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReferFriendsComponent } from '../referfriends-link-generation/referfriends.component';
import { ReferFriendsListComponent } from './referfriends-list.component';

const routes: Routes = [
    {
        path: '',
        component: ReferFriendsListComponent,
        data: {
            title: 'Referred Friend List'
        }
    },
    {
        path: 'add',
        component: ReferFriendsComponent,
        data: {
            title: 'Refer Friends'
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ReferFriendsRoutingModule { }
